export default "__VITE_ASSET__Bz3r_RYk__"